export default {
    xiXiang_PersonalMessage: "Личные сообщения",
    xiXiang_Subscribers: "Пользователи",
    xiXiang_Caption: "Заголовок",
    xiXiang_CreationTime: "Время создания",
    xiXiang_ReadingSituation: "Статус прочтения",
    xiXiang_Particulars: "Подробности",
    xiXiang_Operation: "Действие",
    xiXiang_tipsReadMessage: "Вы уверены, что прочитали это сообщение?",
    xiXiang_tipsReadBtnTitle: "Прочитано",
    xiXiang_tipsIsRead: "Прочитано",
    xiXiang_tipsUnReadBtnTitle: "Не прочитано",
    xiXiang_Cancellations: "Отмена",
    xiXiang_MakeCertain: "Подтвердить",

    xiXiang_HomePage: "Главная",
    xiXiang_EquipmentManagement: "Управление оборудованием",
    xiXiang_WorkOrderManagement: "Управление заявками",
    xiXiang_OperationAndMaintenanceReport: "Отчёт по эксплуатации и обслуживанию",
    xiXiang_MerchantManagement: "Управление арендаторами",
    xiXiang_systemManagement: "Управление системой",
    xiXiang_UserManagement: "Управление пользователями",
    xiXiang_MessageManagement: "Управление сообщениями",
    xiXiang_LoginLog: "Журнал входа",
    xiXiang_OperatingLog: "Журнал операций",

    xiXiang_BigSmartScreen: "Интеллектуальный экран",
    xiXiang_DecisionMakingCommandAtAGlance: "Обзор решений и управления",
    xiXiang_RoutineInspection: "Повседневный осмотр",
    xiXiang_ViewInspectionCompletionRates: "Просмотр процента выполнения осмотров",
    "xiXiang_ViewO&MReports": "Просмотр отчётов по эксплуатации и обслуживанию",
    xiXiang_WorkOrderReporting: "Подача заявки",
    xiXiang_ViewWorkOrderReporting: "Просмотр подачи заявок",

    xiXiang_PercentageOfEquipment: "Доля оборудования",

    xiXiang_EquipmentOverview: "Обзор оборудования",
    xiXiang_TotalEquipment: "Всего оборудования",
    xiXiang_CallThePoliceToday: "Тревоги за сегодня",
    xiXiang_TroubleshootingToday: "Неисправности за сегодня",
    xiXiang_InstallationToday: "Установки за сегодня",
    xiXiang_MaintenanceToday: "Обслуживание за сегодня",

    xiXiang_EquipmentOnlineRate: "Процент онлайн-оборудования",
    xiXiang_EquipmentOfflineRate: "Процент офлайн-оборудования",
    xiXiang_EquipmentFailureRate: "Процент неисправностей оборудования",
    xiXiang_EquipmentAlarmRate: "Процент тревог оборудования",

    xiXiang_AlarmOverview: "Обзор тревог",
    xiXiang_TotalNumberOfAlarms: "Всего тревог",
    xiXiang_AlarmsProcessed: "Обработанные тревоги",
    xiXiang_UnprocessedAlarms: "Необработанные тревоги",

    xiXiang_Faultprofile: "Обзор неисправностей",
    xiXiang_TotalNumberOfFaults: "Всего неисправностей",
    xiXiang_Troubleshooting: "Обработанные неисправности",
    xiXiang_UntreatedFaults: "Необработанные неисправности",
}
